import { useMemo } from "react";
import { useSelector } from "react-redux";

const useVipInfo = () => {
  const memberData = useSelector((state) => state.isMemberInfo);

  const { vipInfo } = memberData;

  const vipConfig = useMemo(() => {
    return {
      nowLevel: vipInfo?.vip_lv_now,
      nowWash: vipInfo?.vip_wash,
      nowDeposit: vipInfo?.vip_deposit,
      nowGift: vipInfo?.vip_gift,
      nowSteer: vipInfo?.vip_steer,
    };
  }, [vipInfo, memberData]);

  return vipConfig;
};

export default useVipInfo;
